export const defaultInfo = {
    'avatar': require('@/index/assets/img/avatar.jpg'),
    'city': '苏州市',
    'country': '中国',
    'sex': 3,
    'e_account_role': 'i',
    'name': '小怪兽',
    'douyin_mark': 'xggmyy444333',
    'province': '江苏省',
    'count': 235236,
    'fans_list': [
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国'
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国'
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国'
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国'
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国'
        },
    ],
    'phone': '13226915123',
    'attention_list': [
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国',
            'phone': '13226915123',
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国',
            'phone': '13226915123',
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国',
            'phone': '13226915123',
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国',
            'phone': '13226915123',
        },
        {
            'sex': 2,
            'name': '张三',
            'avatar': require('@/index/assets/img/avatar.jpg'),
            'city': '杭州',
            'province': '浙江',
            'country': '中国',
            'phone': '13226915123',
        },
    ],
    'result_list': [
        {
            'new_transmit': 1838532,
            'total_content': 23,
            'new_content': 1,
            'sum_fans': 1419,
            'fresh_fans': 1419,
            'fresh_like': 10478,
            'add_comment': 395,
            'add_share': 237,
            'people_visit': 7889,
            'date': '2022-03-10'
        },
        {
            'new_transmit': 4448532,
            'total_content': 24,
            'new_content': 1,
            'sum_fans': 4961,
            'fresh_fans': 3542,
            'fresh_like': 93745,
            'add_comment': 2087,
            'add_share': 34784,
            'people_visit': 45758,
            'date': '2022-03-11'
        },
        {
            'new_transmit': 342427,
            'total_content': 25,
            'new_content': 2,
            'sum_fans': 9108,
            'fresh_fans': 4147,
            'fresh_like': 8042,
            'add_comment': 197,
            'add_share': 203,
            'people_visit': 37,
            'date': '2022-03-12'
        },
        {
            'new_transmit': 24242,
            'total_content': 26,
            'new_content': 1,
            'sum_fans': 15794,
            'fresh_fans': 6688,
            'fresh_like': 1357,
            'add_comment': 20,
            'add_share': 45,
            'people_visit': 8,
            'date': '2022-03-13'
        },
        {
            'new_transmit': 78221,
            'total_content': 27,
            'new_content': 1,
            'sum_fans': 19515,
            'fresh_fans': 3721,
            'fresh_like': 3098,
            'add_comment': 78,
            'add_share': 44,
            'people_visit': 12,
            'date': '2022-03-14'
        },
        {
            'new_transmit': 387,
            'total_content': 28,
            'new_content': 1,
            'sum_fans': 22296,
            'fresh_fans': 2871,
            'fresh_like': 20,
            'add_comment': 0,
            'add_share': 0,
            'people_visit': 2,
            'date': '2022-03-15'
        },
        {
            'new_transmit': 32283,
            'total_content': 29,
            'new_content': 1,
            'sum_fans': 31709,
            'fresh_fans': 9413,
            'fresh_like': 2473,
            'add_comment': 45,
            'add_share': 20,
            'people_visit': 64,
            'date': '2022-03-16'
        }
    ],
    'antistop': '宝马（18）, 劳斯莱斯（43）',
    'fans_antistop': '优秀（18）, 秀我一脸（43）',
    'interest_distributions': [],
    'fans_age_distributes': ['1-24（18）', '25-30（43）', '31-40（43）'],
    'territory_distributes': ['浙江（18）', '江苏（43）', '河南（18）', '河北（43）'],
    'withholding_money': 0
}
